/*
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *     http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */
import {Dataset, DatasetType} from './dataset';

/**
 * Create table data object from paragraph table type result
 */
export default class TableData extends Dataset {
  constructor(columns, rows, comment) {
    super();
    this.columns = columns || [];
    this.rows = rows || [];
    this.comment = comment || '';
  }

  loadParagraphResult(paragraphResult) {
    if (!paragraphResult || paragraphResult.type !== DatasetType.TABLE) {
      console.warn('Can not load paragraph result');
      return;
    }

    let columns = [];
    let rows = [];
    let textRows = paragraphResult.msg.split('\n');
    let comment = '';
    let commentRow = false;

    let hasTypes = false;

    if (textRows.length > 1) {
      const expected = ['string', 'boolean', 'number', 'date', 'object'];
      const types = textRows[1].split('\t');
      hasTypes = _.all(types, (t) => _.includes(expected, t));
    }

    for (let i = 0; i < textRows.length; i++) {
      let textRow = textRows[i];

      if (commentRow) {
        comment += textRow;
        continue;
      }

      if (textRow === '' || textRow === '<!--TABLE_COMMENT-->') {
        if (rows.length > 0) {
          commentRow = true;
        }
        continue;
      }

      let textCols = textRow.split('\t');
      let row = [];
      for (let j = 0; j < textCols.length; j++) {
        const col = textCols[j];
        if (i === 0) {
          columns.push({name: col, index: j, aggr: 'sum', type: 'string'});
        } else if (i === 1 && hasTypes) {
          if (col === 'number') {
            columns[j].type = 'numberStr';
          } else {
            columns[j].type = col;
          }
        } else {
          row.push(col);
        }
      }

      if (i > 1 || (!hasTypes && i > 0)) {
        rows.push(row);
      }
    }
    this.comment = comment;
    this.columns = columns;
    this.rows = rows;
  }
}



// WEBPACK FOOTER //
// ./src/app/tabledata/tabledata.js